/** Display helpers for Users.legacy_source (v1-new / v1-partial / v1 / v0). */

export type LegacySourceBadgeInfo = {
  label: string;
  color: string;
};

export const getLegacySourceBadge = (
  source: string | null | undefined
): LegacySourceBadgeInfo | null => {
  if (source == null || String(source).trim() === '') return null;
  const s = String(source).trim().toLowerCase();

  if (s === 'v1-new') {
    return { label: 'NEW · Legacy V1', color: 'teal' };
  }
  if (s === 'v1-partial') {
    return { label: 'PARTIAL · Legacy V1', color: 'orange' };
  }
  if (s === 'v1') {
    return { label: 'Legacy V1', color: 'orange' };
  }
  if (s === 'v0' || s.startsWith('v0')) {
    return { label: `Legacy ${String(source).toUpperCase()}`, color: 'grape' };
  }
  return { label: `Legacy ${String(source).toUpperCase()}`, color: 'gray' };
};
